import { render } from "./operation.vue?vue&type=template&id=4de7afaf&scoped=true"
import script from "./operation.vue?vue&type=script&lang=js"
export * from "./operation.vue?vue&type=script&lang=js"

import "./operation.vue?vue&type=style&index=0&id=4de7afaf&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4de7afaf"

export default script